import React from "react";
import { getFieldValue } from "@sitecore-jss/sitecore-jss-react";
import {
  useUiValue,
  closeSuccessModal,
  closeRegistrationModal,
  closeSuccessModalPromo,
  closeSuccessModalInvestors,
  closeSuccessModalWarranty,
} from "stores/uiContext";

import loadable from "@loadable/component";
const SuccessfulModal = loadable(() =>
  import("components/components/organisms/SuccessfulModal")
);
const FormsConfirmationModal = ({ fields }) => {
  const titleRegistrationForm = getFieldValue(fields, "titleRegistrationForm");
  const textRegistrationForm = getFieldValue(fields, "textRegistrationForm");
  const titlePromoForm = getFieldValue(fields, "titlePromoForm");
  const textPromoForm = getFieldValue(fields, "textPromoForm");
  const titleWarrantyForm = getFieldValue(fields, "titleWarrantyForm");
  const textWarrantyForm = getFieldValue(fields, "textWarrantyForm");
  const cta = getFieldValue(fields, "cta");

  const [
    {
      showSuccessModal,
      showSuccessModalPromo,
      showSuccessModalInvestors,
      showSuccessModalWarranty,
    },
    dispatch,
  ] = useUiValue();

  const handleClose = () => {
    dispatch(closeSuccessModal());
    dispatch(closeRegistrationModal());
    dispatch(closeSuccessModalPromo());
    dispatch(closeSuccessModalInvestors());
    dispatch(closeSuccessModalWarranty());
  };

  const title = showSuccessModalPromo
    ? titlePromoForm
    : showSuccessModalWarranty
    ? titleWarrantyForm
    : titleRegistrationForm;
  const text = showSuccessModalPromo
    ? textPromoForm
    : showSuccessModalWarranty
    ? textWarrantyForm
    : textRegistrationForm;

  return (
    <div>
      <SuccessfulModal
        title={title}
        text={text}
        cta={cta}
        isOpen={
          showSuccessModal ||
          showSuccessModalPromo ||
          showSuccessModalInvestors ||
          showSuccessModalWarranty
        }
        onClose={handleClose}
      />
    </div>
  );
};

export default FormsConfirmationModal;
